<div class="dialog-container">
  <div class="dialog-header">
    <h1 class="dialog-title">{{ data.title }}</h1>
    <button mat-icon-button type="button" aria-label="Close" (click)="dismiss()"><mat-icon>close</mat-icon></button>
  </div>
  @if (data.hint) { <p class="dialog-hint">{{ data.hint }}</p> }
  <div class="field">
    <label class="field-label" for="map-layer-group-name">Group name</label>
    <input id="map-layer-group-name" class="field-input" type="text" [(ngModel)]="name" (ngModelChange)="error = ''"
           (keydown.enter)="confirm(); $event.preventDefault()" maxlength="256" autocomplete="off"
           placeholder="e.g. Utilities or Landscape" cdkFocusInitial />
    @if (error) { <p class="field-error" role="alert">{{ error }}</p> }
  </div>
  <div class="group-dialog-actions">
    <app-secondary-button (handleClick)="dismiss()" class="flex-1">Cancel</app-secondary-button>
    <app-primary-button (handleClick)="confirm()" [isDisabled]="!canConfirm" class="flex-1">{{ data.confirmLabel }}</app-primary-button>
  </div>
</div>
